import React, { useEffect, useState } from "react";
import DiceRoller from "../../DiceRoller";
import Marvel84Roller from "../../Marvel84Roller";
import VtMDiceRoller from "../../VtMDiceRoller"

const ROLLERS = [
  { key: "default", label: "Default" },
  { key: "marvel84", label: "Marvel Super Heroes" },
  { key: "vampire", label: "Vampire: Masquerade"},
];

export default function DicePanel({ socket, username, roomName }) {
  const [rollerKey, setRollerKey] = useState("default");

  // optional: remember choice
  useEffect(() => {
    const saved = localStorage.getItem("rollcall.rollerKey");
    if (saved) setRollerKey(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem("rollcall.rollerKey", rollerKey);
  }, [rollerKey]);

  return (
    <div
      style={{
        width: "180px",
        background: "#222",
        borderRight: "2px solid #444",
        padding: "10px",
        overflowY: "auto",
      }}
    >
      <h2 style={{ textAlign: "center", color: "white", fontSize: "1.0rem", marginBottom: "0.75rem" }}>
        Dice Table 🎲
      </h2>

      <div style={{ marginBottom: "10px" }}>
        {/*<label style={{ color: "#ddd", fontSize: "12px", display: "block", marginBottom: "6px" }}>
          Roller
        </label> */}
        <select
          value={rollerKey}
          onChange={(e) => setRollerKey(e.target.value)}
          style={{
            width: "100%",
            padding: "6px",
            borderRadius: "6px",
            border: "1px solid #555",
            background: "#111",
            color: "#fff",
          }}
        >
          {ROLLERS.map((r) => (
            <option key={r.key} value={r.key}>
              {r.label}
            </option>
          ))}
        </select>
      </div>

      {rollerKey === "default" && <DiceRoller socket={socket} username={username} roomName={roomName} />}
      {rollerKey === "marvel84" && <Marvel84Roller socket={socket} username={username} roomName={roomName} />}
      {rollerKey === "vampire" && <VtMDiceRoller socket={socket} username={username} roomName={roomName} />}
    </div>
  );
}
